class EndlessScroll {
  constructor() {
    this.container = document.querySelector('.product-list__inner');
    this.paginationWrapper = document.querySelector('page-pagination');
    this.isLoading = false;
    this.page = 2;

    if (this.container && this.paginationWrapper) {
      this.setupObserver();
    }
  }

  setupObserver() {
    const sentinel = document.createElement('div');
    sentinel.id = 'scroll-sentinel';
    this.paginationWrapper.after(sentinel);

    this.sentinelObserver = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !this.isLoading) {
        this.loadMore();
      }
    });

    this.sentinelObserver.observe(sentinel);
  }

  async loadMore() {
    // מחיקת הפאג'ינציה הקודמת אם קיימת
    if (this.paginationWrapper) {
      this.paginationWrapper.remove();
    }

    const url = new URL(window.location.href);
    url.searchParams.set('page', this.page);

    this.isLoading = true;

    try {
      const res = await fetch(url.toString());
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      const newItems = doc.querySelectorAll('.product-list__inner .product-item');
      newItems.forEach(item => this.container.appendChild(item));

      const newPagination = doc.querySelector('page-pagination');
      if (!newPagination) {
        this.sentinelObserver.disconnect();
      }

      history.pushState(null, '', url.toString());
      this.page++;
    } catch (error) {
      console.error('Endless Scroll Error:', error);
    } finally {
      this.isLoading = false;
    }
  }
}

// אתחול מחדש אחרי סינון או מיון
function reinitEndlessScrollOnFacetedNavigation() {
  document.addEventListener('shopify:section:load', () => {
    if (window._endlessScrollInstance) {
      window._endlessScrollInstance.sentinelObserver?.disconnect?.();
    }
    window._endlessScrollInstance = new EndlessScroll();
  });

  document.addEventListener('facet:criteria-changed', () => {
    setTimeout(() => {
      if (window._endlessScrollInstance) {
        window._endlessScrollInstance.sentinelObserver?.disconnect?.();
      }
      window._endlessScrollInstance = new EndlessScroll();
    }, 300);
  });
}

// הפעלה ראשונית
document.addEventListener('DOMContentLoaded', () => {
  window._endlessScrollInstance = new EndlessScroll();
  reinitEndlessScrollOnFacetedNavigation();
});
